import { Skill } from '../creep-skill';

export const DASH: Skill = {
  name: 'dash',
  desk: `Move one extra square in the same direction as the current move action. Cooldown
    <span><b>10</b>/<b>8</b>/<b>6</b>/<b>4</b>/<b>2</b></span> ticks.`
} as Skill;

export const REGENERATE: Skill = {
  name: 'regenerate',
  desk: `Heal the power creep itself for 
    <span><b>1000</b>/<b>2000</b>/<b>3000</b>/<b>4000</b>/<b>5000</b></span>
    hits. Cooldown 5 ticks.`
} as Skill;

export const HARVEST_ENERGY: Skill = {
  name: 'harvest_energy',
  desk: `Harvest
    <span><b>200</b>/<b>400</b>/<b>600</b>/<b>800</b>/<b>1000</b></span>
    energy units from an energy source. Cooldown 20 ticks.`
} as Skill;

export const HARVEST_MINERAL: Skill = {
  name: 'harvest_mineral',
  desk: `Harvest
    <span><b>200</b>/<b>400</b>/<b>600</b>/<b>800</b>/<b>1000</b></span>
    units from a mineral deposit. Cooldown 40 ticks.`
} as Skill;

export const HARVEST_DEPOSIT: Skill = {
  name: 'harvest_deposit',
  desk: `Harvest
    <span><b>200</b>/<b>400</b>/<b>600</b>/<b>800</b>/<b>1000</b></span>
    units from a commodity deposit. Cooldown 40 ticks.`
} as Skill;

export const REMOTE_TRANSFER: Skill = {
  name: 'remote_transfer',
  desk: `Remotely transfer resources to any creep or structure. Range 
    <span><b>5</b>/<b>10</b>/<b>15</b>/<b>20</b>/<b>30</b></span> squares. Cooldown 10 ticks.`
} as Skill;

export const MASS_REPAIR: Skill = {
  name: 'mass_repair',
  desk: `Repair all structures in 10 squares range area for up to
    <span><b>1000</b>/<b>2000</b>/<b>3000</b>/<b>4000</b>/<b>5000</b></span>
    hits in total. Repair effect is distributed between all structures. Consumes up to
    <span><b>10</b>/<b>20</b>/<b>30</b>/<b>40</b>/<b>50</b></span>
    energy.`
} as Skill;

export const SNIPE: Skill = {
  name: 'snipe',
  desk: `Inflict 300 damage to the target creep or power creep in <span><b>1</b>/<b>2</b>/<b>3</b>/<b>4</b>/<b>5</b></span> squares range, even if it is inside ramparts. 
    Cannot be used with structures. No cooldown.`,
  requiresLevel: [20, 21, 22, 23, 24]
} as Skill;

export const PUNCH: Skill = {
  name: 'punch',
  desk: `Inflict
    <span><b>300</b>/<b>600</b>/<b>900</b>/<b>1200</b>/<b>1500</b></span>
    damage to the target creep, power creep, or structure in melee range. No cooldown.`
} as Skill;

export const DEMOLISH: Skill = {
  name: 'demolish',
  desk: `Inflict
    <span><b>5K</b>/<b>10K</b>/<b>15K</b>/<b>20K</b>/<b>25K</b></span>
    damage to the target rampart or wall. Range 10 squares. Cooldown 10 ticks.`
} as Skill;

export const REINFORCE: Skill = {
  name: 'reinforce',
  desk: `Make the creep itself invulnerable for attacks on the next 3 ticks. Cooldown
    <span><b>20</b>/<b>18</b>/<b>16</b>/<b>14</b>/<b>12</b></span>
    ticks.`,
  requiresLevel: [10, 11, 12, 14, 22]
} as Skill;

export const REFLECT: Skill = {
  name: 'reflect',
  desk: `Reflect 50% of damage inflicted to the power creep back to an attacker creep, even it is inside ramparts. Effect duration 5 ticks, cooldown
    <span><b>20</b>/<b>18</b>/<b>16</b>/<b>14</b>/<b>12</b></span>
    ticks.`
} as Skill;

export const KILL: Skill = {
  name: 'kill',
  desk: `Instantly kills any creep in 3 squares range if it's not inside hostile ramparts. Cooldown
    <span><b>900</b>/<b>800</b>/<b>700</b>/<b>600</b>/<b>500</b></span>
    ticks.`,
  requiresLevel: [20, 21, 22, 23, 24]
} as Skill;

export const NUKE: Skill = {
  name: 'nuke',
  desk: `Drops a nuke on the same square with 
    <span><b>90000</b>/<b>80000</b>/<b>70000</b>/<b>60000</b>/<b>50000</b></span> ticks to land.
    The power creep dies immediately after using this power. If a nuke of the same power creep 
    is already present in the same room, using this power again will remove the previous one. If the power creep is deleted,
    all its nukes are also removed.`,
  requiresLevel: [20, 21, 22, 23, 24]
} as Skill;


export const EXECUTOR_SKILLS = [
  DASH,
  REGENERATE,
  HARVEST_ENERGY,
  HARVEST_MINERAL,
  HARVEST_DEPOSIT,
  REMOTE_TRANSFER,
  MASS_REPAIR,
  PUNCH,
  DEMOLISH,
  REFLECT,
  REINFORCE,
  SNIPE,
  KILL,
  NUKE
];



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/skills/skills.executor.ts